import { createGlobalRoute } from '@townsquare/router/create-route';

export const agentStudioRoute = createGlobalRoute({
  exact: true,
  name: 'agent-studio',
  path: '/agent-studio',
  layout: 'home',
  nav4Layout: 'expanded',
});
